import React from "react";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../_metronic/_helpers";

export function ScrollTop() {
  return (
      <div id="kt_scrolltop" className="scrolltop">
        <SVG src={toAbsoluteUrl("/media/svg/general/torna-su.svg")}></SVG>
      </div>
  );
}
